export const FETCH_PAST_RECORDS_SUCCESS = 'FETCH_PAST_RECORDS_SUCCESS';
export const FETCH_PAST_RECORDS_FAIL ='FETCH_PAST_RECORDS_FAIL';
export const FETCH_PAST_RECORDS_START = 'FETCH_PAST_RECORDS_START';

export const UPLOAD_PAST_RECORD_START = 'UPLOAD_PAST_RECORD_START';
export const UPLOAD_PAST_RECORD_SUCCESS = 'UPLOAD_PAST_RECORD_SUCCESS';
export const UPLOAD_PAST_RECORD_FAIL = 'UPLOAD_PAST_RECORD_FAIL';
